import { useEffect } from 'react';
import { useHospitalityStore } from '../store/useHospitalityStore';

/**
 * Drives the 60ms eased number-tween so the dashboard counters animate smoothly
 * toward their live targets (KPIs from the dashboard SSE stream, occupancy from
 * the real floor state). The old paced "event generator" (random KPI drift +
 * fabricated SUKI feed items) has been removed with the rest of the mock data —
 * KPIs now move only when the backend sends real values, and the activity feed
 * fills only from real operator actions (store.pushEvent).
 */
export function useSim(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const ease = setInterval(() => useHospitalityStore.getState().ease(), 60);
    return () => clearInterval(ease);
  }, [enabled]);
}
